import { Side } from '@radix-ui/react-popper';
import styled from 'styled-components';

import { Z_INDICES } from 'dashboard/styles/variables';
import Sticker from 'design-system/components/Sticker';
import { Paragraph } from 'design-system/components/Text';
import Tooltip from 'design-system/components/Tooltip';

const StickerWrapper = styled('div')`
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  cursor: default;
`;

interface BiometricBadgeProps {
  tooltipSide?: Side;
  stored?: boolean;
  dataMarketingId?: string;
  dataTest?: string;
}

const BiometricBadge = ({
  tooltipSide = 'right',
  stored = false,
  dataMarketingId,
  dataTest,
}: BiometricBadgeProps) => {
  return (
    <Tooltip
      side={tooltipSide}
      data-test={dataTest}
      zIndex={Z_INDICES.modalElevated}
      trigger={
        <div>
          <StickerWrapper data-marketing-id={dataMarketingId}>
            <Sticker variant='danger'>Biometric</Sticker>
          </StickerWrapper>
        </div>
      }
    >
      {stored ? (
        <Paragraph>
          <strong>Biometric storage is required to the use this feature.</strong>
          <br />
          We recommend consulting with your legal team and compliance advisors
          <br />
          to ensure that your business meets the proper requirements to
          <br />
          process and store this biometric data within Persona.
        </Paragraph>
      ) : (
        <Paragraph>
          <strong>Biometric processing is required to use this feature.</strong> We recommend
          <br />
          consulting with your legal team and compliance advisors to ensure that your
          <br />
          business meets the proper requirements to process this biometric data.
        </Paragraph>
      )}
    </Tooltip>
  );
};

export default BiometricBadge;
